import { css } from 'styled-components'
export default function ({
  headingWrapperProps,
  imageWrapperProps,
}) {
  return {
    triangleProps: {
      clipDisabled: false,
      clipReversed: true,
    },
    wrapperProps: {
      mobileWrapperStyles: css`
        margin-bottom: 200px;
        padding-top: 20px;
      `,
      tabletWrapperStyles: css`
        margin-bottom: 265px;
        padding-top: 35px;
      `,
      desktopWrapperStyles: css`
        margin-bottom: 100px;
        padding-bottom: 20px;
        padding-top: 80px;
      `,
    },
    containerProps: {
      mobileContainerStyles: null,
      tabletContainerStyles: null,
      desktopContainerStyles: css`
        flex-direction: row;
        justify-content: space-between;
      `,
    },
    headingWrapperProps: {
      ...headingWrapperProps,
      mobileContainerStyles: null,
      tabletContainerStyles: null,
      desktopContainerStyles: css`
        width: 30%;
      `,
    },
    imageWrapperProps: {
      ...imageWrapperProps,
      mobileImageWrapperStyles: css`
        margin-bottom: -160px;
        margin-top: 30px;
        width:86%;
        z-index: 100;
      `,
      tabletImageWrapperStyles: css`
        margin-bottom: -155px;
        margin-top: 50px;
        width: 65%;
      `,
      desktopImageWrapperStyles: css`
        margin-bottom: 0;
        margin-top: 0;
        width: 56%;
      `,
      mobileImageStyles: null,
      tabletImageStyles: null,
      desktopImageStyles: null,
    },
  }
}

// imageMobile: {
//   url: withPrefix('img/ArHeroHeaderUsecasesMga.png'),
//   alt: '',
// },
// imageTablet: {
//   url: withPrefix('img/ArHeroHeaderUsecasesMga.png'),
//   alt: '',
// },
// imageDesktop: null,
